// extracted by mini-css-extract-plugin
export default {"customInput":"CustomInput_customInput__jMHrh"};